import dayjs, { Dayjs } from "dayjs";
import { useEffect, useMemo, useState } from "react";

const computeCountdown = (startDate: Dayjs, now: Dayjs) => {
  const startTime = dayjs(startDate);

  const daysDiff = startTime.diff(now, "day");
  const hoursDiff = startTime.diff(now, "hour") - daysDiff * 24;
  const minutesDiff =
    startTime.diff(now, "minute") - daysDiff * 24 * 60 - hoursDiff * 60;

  return { daysDiff, hoursDiff, minutesDiff };
};

export const useCountDown = (startDate: Dayjs) => {
  const [now, setNow] = useState<Dayjs | null>(null);

  useEffect(() => {
    const scheduleNextUpdate = () => {
      const current = dayjs();
      setNow(current);

      const msUntilNextMinute =
        (60 - current.second()) * 1000 - current.millisecond() + 50;

      return setTimeout(scheduleNextUpdate, msUntilNextMinute);
    };

    const timeoutId = scheduleNextUpdate();
    return () => clearTimeout(timeoutId);
  }, []);

  const { daysDiff, hoursDiff, minutesDiff } = useMemo(() => {
    if (!now) return { daysDiff: 0, hoursDiff: 0, minutesDiff: 0 };
    return computeCountdown(startDate, now);
  }, [startDate, now]);

  return { daysDiff, hoursDiff, minutesDiff, now };
};
